// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerInputId } from './lecturerInputId';
import type { LecturerInputAvatar } from './lecturerInputAvatar';

/**
 * Lecturer that can be author or corrector of a module
 */
export interface LecturerInput {
  id?: LecturerInputId;
  name: string;
  title: string;
  firstname: string;
  lastname: string;
  avatar?: LecturerInputAvatar;
}
